import {Reveal} from '@/components/motion/Reveal';
import {Floating} from '@/components/motion/Floating';
import {Sparkle} from '@/components/motion/Sparkle';
import {VendorForm} from '@/components/vendors/VendorForm';
import {Rules} from '@/components/vendors/Rules';
import {asset} from '@/lib/asset';
import {EYEBROW_LABEL} from '@/lib/registration-window';

const STEPS = [
  {
    title: 'Envía tu solicitud',
    body: 'Completa el formulario con la información de tu negocio. Toma menos de 5 minutos y no cuesta nada.',
  },
  {
    title: 'Proceso de selección',
    body: 'El equipo de Navimarket evalúa las solicitudes buscando una mezcla variada de negocios locales.',
  },
  {
    title: 'Confirma tu espacio',
    body: 'Si eres seleccionado, recibirás un correo con los próximos pasos y los detalles de tu booth.',
  },
];

const INCLUDED = [
  ['Booth de 8×8', 'Tu espacio en el bazar, listo para montar tu marca.'],
  ['Mesa, mantel y silla', 'Disponibles si los necesitas — los pides en el formulario.'],
  ['Tráfico real', 'Más de 10,000 personas visitaron la edición 2025.'],
  ['Cobra con ATH Business', 'El evento mueve sus pagos con ATH Móvil, tu negocio cobra al instante.'],
] as const;

export function VendorsPanel() {
  return (
    <div id="vendors" className="scroll-mt-32">
      {/* Participación */}
      <section aria-labelledby="participa-title" className="relative mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:py-20">
        <Sparkle className="absolute right-10 top-8 hidden lg:block" size={22} />
        <Sparkle className="absolute bottom-16 left-2 hidden opacity-70 lg:block" size={14} delay={1.4} />
        <div className="grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:gap-16">
          <div className="relative">
            <Reveal>
              <p className="overline-label text-amber">{EYEBROW_LABEL}</p>
              <h2 id="participa-title" className="mt-3 text-balance text-3xl font-bold text-white sm:text-4xl">
                Vende en el bazar más grande de Puerto Rico, <span className="text-amber">gratis</span>.
              </h2>
              <p className="mt-4 max-w-lg text-pretty leading-relaxed text-cream/90">
                Navimarket reúne a más de 200 negocios locales para abrir la temporada navideña. Participar no tiene
                costo — solo necesitas estar registrado en{' '}
                <a
                  href="https://athmovil.com/personas/ath-business"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-amber underline underline-offset-4 hover:text-cream-bright"
                >
                  ATH Business
                </a>
                .
              </p>
            </Reveal>

            <Reveal delay={0.15} className="mt-10">
              <ol className="relative space-y-8 border-l border-white/12 pl-6">
                {STEPS.map((s, i) => (
                  <li key={s.title} className="relative">
                    <span
                      aria-hidden
                      className="absolute -left-[31px] flex h-2.5 w-2.5 items-center justify-center rounded-full bg-amber shadow-[0_0_10px_2px_rgba(237,171,67,0.45)]"
                    />
                    <p className="text-sm font-medium uppercase tracking-[0.12em] text-cream/70">Paso {i + 1}</p>
                    <h3 className="mt-1 font-bold text-white">{s.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-cream/85">{s.body}</p>
                  </li>
                ))}
              </ol>
            </Reveal>

            <Floating
              src={asset('img/elements/guiro.webp')}
              alt=""
              className="absolute -right-4 top-2 hidden h-32 w-20 opacity-90 lg:block"
              depth={1}
              drift={8}
            />
          </div>

          <Reveal delay={0.1}>
            {/* superficie cálida del mockup: card crema con texto ink */}
            <div className="rounded-2xl bg-cream p-8 text-ink shadow-[0_24px_60px_-20px_rgba(0,20,16,0.7)] sm:p-10">
              <h3 className="text-xl font-bold">Qué incluye tu participación</h3>
              <dl className="mt-6 divide-y divide-ink/10">
                {INCLUDED.map(([t, d]) => (
                  <div key={t} className="flex gap-4 py-4 first:pt-0 last:pb-0">
                    <span aria-hidden className="mt-1.5 h-2 w-2 shrink-0 rotate-45 bg-tangerine" />
                    <div>
                      <dt className="font-bold">{t}</dt>
                      <dd className="mt-0.5 text-sm leading-relaxed text-ink/75">{d}</dd>
                    </div>
                  </div>
                ))}
              </dl>
              <p className="mt-6 rounded-lg bg-tangerine/15 px-4 py-3 text-sm leading-relaxed text-ink/85">
                <span className="font-bold text-tangerine-deep">Requisito:</span> tu negocio debe estar registrado en
                ATH Business para poder participar. Si aún no lo está, puedes registrarte antes de enviar la solicitud.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <VendorForm />
      <Rules />
    </div>
  );
}
